import React from "react"

import classnames from "classnames"

const CheckmarkIcon = ({checked}) => {

    return (
        <span className={classnames("material-icons-outlined", { "invisible": !checked })}>
            check
        </span>
    )
}

export default CheckmarkIcon


